import {i18n as t} from '@/i18n/i18n-service-provider';

export const getButtonLabel = (name: string): string => {
  if (
    name
    && t.tc('buttons.' + name)
    && t.tc('buttons.' + name) !== 'buttons.' + name
  ) {
    return t.tc('buttons.' + name);
  }

  return name;
};
